/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
window.BiddingPeriod = {
  setupBiddingPeriodInputs() {
    const $biddingStartsAtInput = this._biddingStartsAtInput();
    const $biddingEndsAtInput   = this._biddingEndsAtInput();

    this.initialEndsAtVal = $biddingEndsAtInput.val();

    const biddingDuration = $biddingStartsAtInput.data('bidding-duration');
    if (!biddingDuration) { return; }

    if ((this.initialEndsAtVal === '') && this._startsImmediatelyIsChecked()) { this._setBiddingEndsAtFromNow(); }

    return $biddingStartsAtInput.on('change', event => {
      const newDate = $(event.currentTarget).val();
      if (!this._shouldAutoSetBiddingEndsAt() || this._startsImmediatelyIsChecked() || (newDate === '')) { return; }

      const dateFormat = 'MMM D, YYYY [at] h:mm a';
      const biddingEndsAt = moment(newDate, dateFormat).add(biddingDuration, 'days').format(dateFormat);
      return $biddingEndsAtInput.val(biddingEndsAt);
    });
  },

  setupStartsAtRadioButtons() {
    if ((this._biddingStartsAtInput().val() !== '') || this._isRepostModal()) { this._checkStartsAtRadioButton(); }

    $("#bidding_starts_immediately_0").on('change', () => {
      if (this._shouldAutoSetBiddingEndsAt()) { return this._setBiddingEndsAtFromBiddingStartsAt(); }
    });

    return $("#bidding_starts_immediately_1").on('change', () => {
      if (this._shouldAutoSetBiddingEndsAt()) { return this._setBiddingEndsAtFromNow(); }
    });
  },

  _checkStartsAtRadioButton() {
    return $("#bidding_starts_immediately_0").prop('checked', true);
  },

  _shouldAutoSetBiddingEndsAt() {
    const biddingDurationEnforced = this._biddingEndsAtInput().data('bidding-duration-enforced');
    return (this.initialEndsAtVal === '') || biddingDurationEnforced;
  },

  _isRepostModal() {
    return $('.modal-reveal#repost').length > 0;
  },

  _setBiddingEndsAtFromNow() {
    const $biddingEndsAtInput = this._biddingEndsAtInput();

    const biddingDuration = $biddingEndsAtInput.data('bidding-duration');
    if (!biddingDuration) { return; }

    const biddingDurationFromNow = moment().add(biddingDuration, 'days').format("MMM D, YYYY h:mm a");
    return $biddingEndsAtInput.val(biddingDurationFromNow);
  },

  _setBiddingEndsAtFromBiddingStartsAt() {
    return this._biddingStartsAtInput().trigger('change');
  },

  _startsImmediatelyIsChecked() {
    return $("#bidding_starts_immediately_1").is(':checked');
  },

  _biddingEndsAtInput() {
    return $("input[name='tender[bidding_ends_at]']");
  },

  _biddingStartsAtInput() {
    return $("input[name='tender[bidding_starts_at]']");
  }
};
